import { AppProvider } from "./contexts/app/provider";
import { AppRoutes } from "./routes/index";
import { AmplifyAuthProvider } from "./contexts/authentication/amplify";
import { MaterialProvider } from "./contexts/material_ui";
import { SysMessagesProvider } from "./contexts/sys_messages/provider";
import { SystemMessagesContainer } from "./components/system_messages/container";
import { VersionedDataProvider } from "./contexts/versioned_data/provider";
import { LockForecastProvider } from "./contexts/lock_forecast";

const App = () => {
  return (
    <MaterialProvider>
      <SysMessagesProvider>
        <AmplifyAuthProvider>
          <AppProvider>
            <VersionedDataProvider>
              <LockForecastProvider>
                <AppRoutes />
                <SystemMessagesContainer />
              </LockForecastProvider>
            </VersionedDataProvider>
          </AppProvider>
        </AmplifyAuthProvider>
      </SysMessagesProvider>
    </MaterialProvider>
  );
};

export default App;
